import React, { useEffect, useState } from "react";
import Button from "../../../UI/Buttons/Button";
import { FaArrowLeft } from "react-icons/fa";
import { PiBooksFill } from "react-icons/pi";
import { StepsContainerStyled } from "../../../../styled/Resume";
import CertificationCard from "../../Tools/CertificationCard";
import { useTheme } from "../../../UI/Theme/ThemeContext";

const CertificationInfo = (props) => {
    const {
        step,
        setStep,
        setStepData,
        awardArray,
        handleAwardChange,
        handleDeleteAward,
        handleAddAward,
        certsForwardOrBackward
    } = props;

    const [disableFields, setDisableFields] = useState(false);
    const { themeName } = useTheme();

    //  add awardArray into global stepData
    useEffect(() => {
        setStepData(prev => ({
            ...prev,
            certificationsInfo: awardArray
        }));
    }, [awardArray, setStepData]);

    // only disable Next if there are *incomplete* entries
    useEffect(() => {
        if (!awardArray || awardArray.length === 0) {
            setDisableFields(false); // ✅ allow skipping if empty
            return;
        }

        const isValid = awardArray.every(
            award =>
                award.title?.trim() !== "" && award.issuer?.trim() !== ""
        );
        setDisableFields(!isValid);
    }, [awardArray]);

    const handleClickForward = (e) => {
        if (e) e.preventDefault();
        certsForwardOrBackward("forward");
        if (!disableFields) {
            setStep(step + 1);
        }
    };

    const handleClickBackward = (e) => {
        if (e) e.preventDefault();
        certsForwardOrBackward("backward");
        setStep(step - 1);
    };

    return (
    <StepsContainerStyled theme={themeName}>
            <h2>
                Certifications, Awards & Accomplishments <span>(Optional)</span>
            </h2>

            <CertificationCard
                awardArray={awardArray}
                handleAwardChange={handleAwardChange}
                handleDeleteAward={handleDeleteAward}
                handleAddAward={handleAddAward}
            />

            <div className={step > 1 ? "btnS" : "btn"}>
                <Button
                    justifycontent="start"
                    secondaryLight
                    width="100%"
                    clickHandle={handleClickBackward}
                >
                    <FaArrowLeft />
                    Previous
                </Button>
                    <div className="nextBtnWrap">
                        <Button
                            justifycontent="flex-end"
                            primary
                            width="100%"
                            clickHandle={handleClickForward}
                            disabled={disableFields}
                        >
                            Publication
                            <PiBooksFill />
                        </Button>
                    </div>
            </div>
        </StepsContainerStyled>
    );
};

export default CertificationInfo;